// const state = {};
// const carouselList = document.querySelector('.carousel__list');
// const carouselItems = document.querySelectorAll('.carousel__item');
// const elems = Array.from(carouselItems);

// carouselList.addEventListener('click', function (event) {
//   var newActive = event.target.closest('.carousel__item');

//   if (!newActive || newActive.classList.contains('carousel__item_active')) {
//     return;
//   };
  
//   update(newActive);
// });

// const update = function(newActive) {
//   const newActivePos = newActive.dataset.pos;

//   const current = elems.find((elem) => elem.dataset.pos == 0);
//   const prev = elems.find((elem) => elem.dataset.pos == -1);
//   const next = elems.find((elem) => elem.dataset.pos == 1);
//   const first = elems.find((elem) => elem.dataset.pos == -2);
//   const last = elems.find((elem) => elem.dataset.pos == 2);
  
//   current.classList.remove('carousel__item_active');
  
//   [current, prev, next, first, last].forEach(item => {
//     var itemPos = item.dataset.pos;

//     item.dataset.pos = getPos(itemPos, newActivePos);
//   });

//   // Установка класса активного элемента
//   newActive.classList.add('carousel__item_active');
// };

// const getPos = function (current, active) {
//   const diff = current - active;

//   if (Math.abs(current - active) > 2) {
//     return -current;
//   }

//   return diff;
// }

const state = {};
const carouselList = document.querySelector('.carousel__list');
const carouselItems = document.querySelectorAll('.carousel__item');
const elems = Array.from(carouselItems);

let startX, endX;

carouselList.addEventListener('click', function (event) {
  var newActive = event.target.closest('.carousel__item');

  if (!newActive || newActive.classList.contains('carousel__item_active')) {
    return;
  }
  
  update(newActive);
});

carouselList.addEventListener('touchstart', function (event) {
  startX = event.touches[0].clientX;
});

carouselList.addEventListener('touchmove', function (event) {
  endX = event.touches[0].clientX;
});

carouselList.addEventListener('touchend', function (event) {
  if (startX && endX) {
    const diffX = startX - endX;

    if (Math.abs(diffX) > 50) { // порог для свайпа
      if (diffX > 0) {
        // Свайп влево
        swipeLeft();
      } else {
        // Свайп вправо
        swipeRight();
      }
    }
  }
  startX = null;
  endX = null;
});

const swipeLeft = function() {
  const newActive = elems.find((elem) => elem.dataset.pos == 1);
  if (newActive) {
    update(newActive);
  }
};

const swipeRight = function() {
  const newActive = elems.find((elem) => elem.dataset.pos == -1);
  if (newActive) {
    update(newActive);
  }
};

const update = function(newActive) {
  const newActivePos = newActive.dataset.pos;

  const current = elems.find((elem) => elem.dataset.pos == 0);
  const prev = elems.find((elem) => elem.dataset.pos == -1);
  const next = elems.find((elem) => elem.dataset.pos == 1);
  const first = elems.find((elem) => elem.dataset.pos == -2);
  const last = elems.find((elem) => elem.dataset.pos == 2);
  
  current.classList.remove('carousel__item_active');
  
  [current, prev, next, first, last].forEach(item => {
    var itemPos = item.dataset.pos;

    item.dataset.pos = getPos(itemPos, newActivePos);
  });

  // Установка класса активного элемента
  newActive.classList.add('carousel__item_active');
};

const getPos = function (current, active) {
  const diff = current - active;

  if (Math.abs(current - active) > 2) {
    return -current;
  }

  return diff;
};

// Добавляем обработчик клика на изображение
carouselItems.forEach(item => {
  const img = item.querySelector('img');
  img.addEventListener('click', function (event) {
    var newActive = event.target.closest('.carousel__item');

    if (!newActive || newActive.classList.contains('carousel__item_active')) {
      return;
    }
    
    update(newActive);
  });
});


const scrollLeftFade = function() {
  const newActive = elems.find((elem) => elem.dataset.pos == -1);
  if (newActive) {
    update(newActive);
  }
};

const scrollRightFade = function() {
  const newActive = elems.find((elem) => elem.dataset.pos == 1);
  if (newActive) {
    update(newActive);
  }
};